module.exports = __webpack_public_path__ + "img/btn-atmosphere.26bed3a1.svg";